import { ActivatedRoute, Router } from "@angular/router";
import { PlatformLocation } from '@angular/common';
import { CommonService } from "../common.service";
var AppErrorComponent = (function () {
    function AppErrorComponent(route, router, commonService, platformLocation) {
        this.route = route;
        this.router = router;
        this.commonService = commonService;
        this.platformLocation = platformLocation;
        this.notFind = false;
        this.otherError = false;
        this.loadError = false;
        this.accessError = false;
        this.assetsRoute = "../../assets";
    }
    AppErrorComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.assetsRoute = this.commonService.setAssetsRoute(this.assetsRoute);
        document.documentElement.style.backgroundColor = '#F6F7FC';
        this.route.params.subscribe(function (params) {
            _this.errorStatus = params['status'];
            if (_this.errorStatus === '404') {
                _this.notFind = true;
                _this.loadError = false;
                _this.otherError = false;
            }
            else if (_this.errorStatus === '500') {
                _this.notFind = false;
                _this.loadError = true;
                _this.otherError = false;
            }
            else if (_this.errorStatus === 'permissionDenied') {
                _this.notFind = false;
                _this.loadError = false;
                _this.otherError = false;
                _this.accessError = true;
            }
            else {
                _this.notFind = false;
                _this.loadError = false;
                _this.otherError = true;
            }
        });
    };
    AppErrorComponent.prototype.ngAfterViewInit = function () {
        this.commonService.initPage({
            'backgroundColor': '#F6F7FC'
        });
    };
    AppErrorComponent.prototype.refresh = function () {
        // this._location.back();
        window.history.go(-2);
    };
    AppErrorComponent.prototype.goHome = function () {
        this.platformLocation["location"]["href"] = this.platformLocation["location"]["origin"] + "/ddilearner/v1/user/authorize" + ("?token=" + localStorage.getItem('transtalen-token'));
    };
    return AppErrorComponent;
}());
export { AppErrorComponent };



// WEBPACK FOOTER //
// ./src/app/app-error/app-error.component.ts.pre-build-optimizer.js